class FancyContact extends HTMLElement {
    constructor() {
        super();

      // desktop
        this.fancyContact = document.getElementById('fancy-contact');
        this.fancyContactOpener = document.getElementById('fancy-contact-opener');
  
      // mobile
        this.fancyDrawerContact = document.getElementById('fancy-dw-contact'); 
        this.fancyDrawerContactOpener = document.getElementById('fancy-dw-contact-opener'); 
  
        this.header = document.querySelector('sticky-header');
        this.onBodyClick = this.handleBodyClick.bind(this);
        
        this.fancyContact.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelectorAll('button[type="button"]').forEach((closeButton) => 
            closeButton.addEventListener('click', this.close.bind(this))
        );
        
        this.fancyContactOpener.addEventListener('click', () => this.open(this.fancyContact));
  
        this.fancyContactOpener.addEventListener('click', () => this.open(this.fancyContact));
        this.fancyDrawerContactOpener.addEventListener('click', () => this.show(this.fancyDrawerContact));
  
    }
    show(targetContact){
      if (targetContact.hidden) {
          targetContact.hidden = false;
        } else {
          targetContact.hidden = true;
        }
    }
  
    open(targetContact) {
        targetContact.classList.add('animate', 'active');
        targetContact.addEventListener(
            'transitionend',
            () => {
                targetContact.focus();
                trapFocus(targetContact);
            },
            { once: true }
        );
        
        document.body.addEventListener('click', this.onBodyClick);
    }
  
    close() {
      console.log('close');
        this.fancyContact.classList.remove('active');
        document.body.removeEventListener('click', this.onBodyClick);
        
        removeTrapFocus(this.activeElement);
    }
    
    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
    
    handleBodyClick(evt) {
        const target = evt.target;
        if (target !== this.fancyContactOpener && !this.fancyContactOpener.contains(target) &&
            target !== this.fancyContact && !this.fancyContact.contains(target)) {
            const disclosure = target.closest('details-disclosure, header-menu');
            this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
            this.close();
        }
    }
    
    setActiveElement(element) {
        this.activeElement = element;
    }
  }
  
  customElements.define('fancy-contact', FancyContact);
  